import { render } from "./salesheadertab.vue?vue&type=template&id=7bd1aa61"
import script from "./salesheadertab.vue?vue&type=script&lang=js"
export * from "./salesheadertab.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__